import { useState, useEffect, useMemo } from 'react';
import Lottie from 'lottie-react';

import bagRegistered from '../../../../../animations/reg-complete_v1.json';
import boxRegistered from '../../../../../animations/box-registered.json';
import virtualBoxRegistered from '../../../../../animations/virtual-box-complete.json';

import './RegistrationSuccess.scss';

export default function RegistrationSuccess({
  isTechRecycling,
  onShowingAnimation,
  isVirtualBox,
}) {
  const [currentAnimation, setCurrentAnimation] = useState(0);

  const animations = useMemo(() => {
    const list = [];

    let registeredAnimation;
    if (isVirtualBox) {
      registeredAnimation = virtualBoxRegistered;
    } else if (isTechRecycling) {
      registeredAnimation = boxRegistered;
    } else {
      registeredAnimation = bagRegistered;
    }

    list.push({
      bgColor: isTechRecycling ? 'var(--take-back-bags-lemon-handz)' : '#ffffff',
      animation: registeredAnimation,
      duration: 2000,
    });

    return list;
  }, [isTechRecycling, isVirtualBox]);

  useEffect(() => {
    let timeoutId;
    const currentDuration = animations[currentAnimation].duration;

    if (currentAnimation < animations.length - 1) {
      onShowingAnimation?.(true);

      timeoutId = setTimeout(() => {
        setCurrentAnimation(prev => prev + 1);
      }, currentDuration);
    } else {
      timeoutId = setTimeout(() => {
        onShowingAnimation?.(false);
      }, currentDuration);
    }

    return () => clearTimeout(timeoutId);
  }, [currentAnimation, animations]);

  return (
    <div
      className="RegistrationSuccess"
      style={{ backgroundColor: animations[currentAnimation].bgColor }}
    >
      <Lottie
        animationData={animations[currentAnimation].animation}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
}
